module.exports = __webpack_public_path__ + "img/how-to-flow-r-01.972be727.svg";